<ng-template #template let-config="config" let-columnIds="columnIds" let-selection="selection">
  <div class="table-mobile">
    <mat-card
      appearance="outlined"
      class="table-mobile__card mat-elevation-z1 spacing--margin-vertical"
      *ngFor="let row of config.dataSource.connect().value; let rowIndex = index"
    >
      <mat-card-header class="flex--align-center table-mobile__header">
        <div class="flex__child--auto">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            class="table-mobile__checkbox"
            data-test="table-mobile__checkbox"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            *ngIf="config.select"
          >
          </mat-checkbox>

          {{ row[getPrimaryColumnKey(row, config.primaryColumn)] }}
        </div>
        <ng-container *ngIf="config?.actions?.length > 1">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            data-test="table-mobile__col-actions-button"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let action of config.actions"
              [disabled]="action.disabled(row, action.id)"
              (click)="action.callback(row, action.id)"
              [attr.data-test]="'table-mobile__col-actions-' + action.id"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>
          </mat-menu>
        </ng-container>
        <ng-container *ngIf="config.actions.length === 1">
          <button
            mat-icon-button
            [disabled]="config.actions[0].disabled(row, config.actions[0].id)"
            (click)="config.actions[0].callback(row, config.actions[0].id)"
            [attr.data-test]="'table-mobile__col-actions-' + config.actions[0].id"
          >
            <mat-icon>{{ config.actions[0].icon }}</mat-icon>
          </button>
        </ng-container>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="spacing--margin-all">
        <div
          *ngFor="
            let column of filterColumns(
              config.columns,
              getPrimaryColumnKey(row, config.primaryColumn)
            );
            let index = index
          "
          class="spacing--margin-bottom"
          [attr.data-test]="'table-mobile__' + column.id"
          [hidden]="!expanded[rowIndex] && index >= config.visibleCardColumns"
        >
          <div class="text--label">{{ column.label }}</div>

          <ng-container *ngIf="column.type === tableColumnTypes.NUMBER">
            {{
              column?.disableFormatting
                ? row[column.id]
                : (row[column.id] | agrNumber: column?.digitsInfo)
            }}
          </ng-container>

          <ng-container *ngIf="column.type === tableColumnTypes.CURRENCY">
            {{ column?.disableFormatting ? row[column.id] : (row[column.id] | agrCurrency) }}
          </ng-container>

          <ng-container *ngIf="column.type === tableColumnTypes.DATE">
            {{
              column?.disableFormatting ? row[column.id] : (row[column.id] | agrDate: 'shortDate')
            }}
          </ng-container>

          <ng-container *ngIf="column.type === tableColumnTypes.STRING">
            {{ row[column.id] }}
          </ng-container>

          <ng-container *ngIf="column.type === tableColumnTypes.TEMPLATE && !!column.template">
            <ng-container *ngTemplateOutlet="column.template; context: { row: row }"></ng-container>
          </ng-container>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button
          *ngIf="config.columns.length - 1 > config.visibleCardColumns"
          mat-button
          data-test="table-mobile__expand-collapse"
          (click)="toggleExpanded(rowIndex)"
        >
          {{ getExpandedLabel(rowIndex) | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>
